import WeightNumber from './WeightNumber';

export default WeightNumber;
export { WeightNumber };
